<template>
  <div>
    <el-row class="bottom20">
      <div class="el-table el-table--fit el-table--border">
        <table style="width: 100%;">
          <tbody>
          <tr v-for="contractItem in contractItems" :key="contractItem.id">
            <!-- 计费项 -->
            <th :style="getCellStyle(contractItem, 'name', true)">
              <div class="cell">计费项</div>
            </th>
            <td :style="getCellStyle(contractItem, 'name')">
              <div class="cell">
                <span>{{contractItem.name}}</span>
                <span v-html="getOldDataTag(contractItem, 'name')"></span>
              </div>
            </td>
            <!-- 累计：ACCUM -->
            <th v-if="contractItem.contractConfigItem != null && contractItem.contractConfigItem.billingCategory === 'ACCUM' &&
                contractItem.contractConfigItem.billingContent === 'IDLE'" :style="getCellStyle(contractItem, 'threshold', true)">
              <div class="cell">起征点</div>
            </th>
            <td v-if="contractItem.contractConfigItem != null && contractItem.contractConfigItem.billingCategory === 'ACCUM' &&
                contractItem.contractConfigItem.billingContent === 'IDLE'" :style="getCellStyle(contractItem, 'threshold')">
              <div class="cell">
                  <span>{{contractItem.threshold}}</span>({{contractItem.contractConfigItem.calculateUnit}})
                  <span v-html="getOldDataTag(contractItem, 'threshold', 2)"></span>
              </div>
            </td>
            <th v-if="contractItem.contractConfigItem != null && contractItem.contractConfigItem.billingCategory === 'ACCUM'"
                :style="getCellStyle(contractItem, 'rate', true)">
              <div class="cell">费用</div>
            </th>
            <td v-if="contractItem.contractConfigItem != null && contractItem.contractConfigItem.billingCategory === 'ACCUM'"
                :colspan="contractItem.contractConfigItem.billingContent === 'IDLE' ? 1 : 3"
                :style="getCellStyle(contractItem, 'rate')">
              <div class="cell">
                <span>{{contractItem.rate}}</span>(元/{{contractItem.contractConfigItem.calculateUnit}})
                <span v-html="getOldDataTag(contractItem, 'rate', 1)"></span>
              </div>
            </td>
            <!-- 限额：QUOTO -->
            <th v-if="contractItem.contractConfigItem != null && contractItem.contractConfigItem.billingCategory === 'QUOTO'"
                :style="getCellStyle(contractItem, 'quota', true)">
              <div class="cell">限额</div>
            </th>
            <td v-if="contractItem.contractConfigItem != null && contractItem.contractConfigItem.billingCategory === 'QUOTO'"
                :style="getCellStyle(contractItem, 'quota')">
              <div class="cell">
                <span>{{contractItem.quota}}</span>({{contractItem.contractConfigItem.calculateUnit}})
                <span v-html="getOldDataTag(contractItem, 'quota', 2)"></span>
              </div>
            </td>
            <th v-if="contractItem.contractConfigItem != null && contractItem.contractConfigItem.billingCategory === 'QUOTO'"
                :style="getCellStyle(contractItem, 'rate', true)">
              <div class="cell">超额费</div>
            </th>
            <td v-if="contractItem.contractConfigItem != null && contractItem.contractConfigItem.billingCategory === 'QUOTO'"
                :style="getCellStyle(contractItem, 'rate')">
              <div class="cell">
                <span>{{contractItem.rate}}</span>(元/{{contractItem.contractConfigItem.calculateUnit}})
                <span v-html="getOldDataTag(contractItem, 'rate', 1)"></span>
              </div>
            </td>
            <!-- 保底：COMMIT -->
            <th v-if="contractItem.contractConfigItem != null && contractItem.contractConfigItem.billingCategory === 'COMMIT'"
                :style="getCellStyle(contractItem, 'quota', true)">
              <div class="cell">保底额</div>
            </th>
            <td v-if="contractItem.contractConfigItem != null && contractItem.contractConfigItem.billingCategory === 'COMMIT'"
                :style="getCellStyle(contractItem, 'quota')">
              <div class="cell">
                <span>{{contractItem.quota}}%</span>
                <span v-html="getOldDataTag(contractItem, 'quota', 3)"></span>
              </div>
            </td>
            <th v-if="contractItem.contractConfigItem != null && contractItem.contractConfigItem.billingCategory === 'COMMIT'"
                :style="getCellStyle(contractItem, 'rate', true)">
              <div class="cell">费用</div>
            </th>
            <td v-if="contractItem.contractConfigItem != null && contractItem.contractConfigItem.billingCategory === 'COMMIT'"
                :style="getCellStyle(contractItem, 'rate')">
              <div class="cell">
                <span>{{contractItem.rate}}(元/{{contractItem.contractConfigItem.calculateUnit}})</span>
                <span v-html="getOldDataTag(contractItem, 'rate', 1)"></span>
              </div>
            </td>
            <!-- 开始日期 -->
            <th :style="getCellStyle(contractItem, 'beginDate', true)">
              <div class="cell">开始日期</div>
            </th>
            <td :style="getCellStyle(contractItem, 'beginDate')">
              <div class="cell">
                <span>{{contractItem.beginDate | formatDate}}</span>
                <span v-html="getOldDataTag(contractItem, 'beginDate')"></span>
              </div>
            </td>
            <!-- 结束日期 -->
            <th :style="getCellStyle(contractItem, 'endDate', true)">
              <div class="cell">结束日期</div>
            </th>
            <td :style="getCellStyle(contractItem, 'endDate')">
              <div class="cell">
                <span>{{contractItem.endDate | formatDate}}</span>
                <span v-html="getOldDataTag(contractItem, 'endDate')"></span>
              </div>
            </td>
            <td style="text-align: center;">
              <el-button plain size="minimum" @click="toShow(contractItem)">查看</el-button>
              <el-button type="warning" plain size="minimum" @click="toEdit(contractItem)" :disabled="!isCanEditContractItem(contractItem)">修改</el-button>
              <el-button type="danger" plain size="minimum" @click="toDelete(contractItem)" :disabled="!isCanDeleteContractItem(contractItem)">删除</el-button>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </el-row>
  </div>
</template>

<script>
  import _ from 'lodash';
  import {formatDate} from "element-ui/src/utils/date-util";
  import BillingServer from '@/api/billing';
  import {
    ENUM_CONTRACT_WORKFLOW_STATUS_CONFIRMED,
    ENUM_CONTRACT_WORKFLOW_STATUS_DRAFT,
    ENUM_CONTRACT_WORKFLOW_STATUS_WAPPRNEW
  } from "@/views/billing/contract/contract.common";
  import {handleError} from "@/util/error-util";

  export default {
    name: "ContractItemList",
    props: {
      contractId: {},
      contractWorkflowStatus: {},
      isCanEditContractItem: {
        type: Function,
        default: () => {
          return true;
        }
      },
      isCanDeleteContractItem: {
        type: Function,
        default: () => {
          return true;
        }
      },
    },
    data() {
      return {
        contractItems: [],
      };
    },
    watch: {
      contractId: {
        immediate: true,
        handler(value) {
          this.loadContractItems(value);
        }
      }
    },
    methods: {
      async loadContractItems(contractId) {
        let contractItems = [], confirmedContractItems = [];
        if (contractId != null) {
          let contractConfigItems = [];
          let responses = await Promise.all([
              BillingServer.contract.getContractItemsByContractId(contractId),
              BillingServer.contract.getConfirmedContractItemsByContractId(contractId),
          ]);
          if (responses[0].data.success && responses[1].data.success) {
            contractItems = responses[0].data.data;
            confirmedContractItems = responses[1].data.data;
            let contractConfigItemIds = _.uniqBy(contractItems.map(contractItem => contractItem.billingConfigItem)
                .concat(confirmedContractItems.map(contractItem => contractItem.billingConfigItem)));
            if (contractConfigItemIds.length > 0) {
              let response = await BillingServer.contract.getContractConfigItems(contractConfigItemIds);
              if (response.data.success) {
                contractConfigItems = response.data.data;
              }
            }
          }
          let contractConfigItemMap = _.keyBy(contractConfigItems, 'id');
          confirmedContractItems.forEach(contractItem => {
            contractItem.contractConfigItem = contractConfigItemMap[contractItem.billingConfigItem];
          });
          let confirmedContractItemsMap = _.keyBy(confirmedContractItems, 'uuid');

          contractItems.forEach(contractItem => {
            contractItem.contractConfigItem = contractConfigItemMap[contractItem.billingConfigItem];
            contractItem.oldContractItem = confirmedContractItemsMap[contractItem.uuid];
          });
        }
        this.contractItems = contractItems;
      },
      getCellStyle(contractItem, key, isTitle) {
        let color, backgroundColor;
        let oldContractItem = contractItem.oldContractItem;
        let release = contractItem.release;
        let contractWorkflowStatus = this.contractWorkflowStatus;
        if (null != contractWorkflowStatus && ENUM_CONTRACT_WORKFLOW_STATUS_DRAFT !== contractWorkflowStatus &&
            ENUM_CONTRACT_WORKFLOW_STATUS_WAPPRNEW !== contractWorkflowStatus &&
            ENUM_CONTRACT_WORKFLOW_STATUS_CONFIRMED !== contractWorkflowStatus) {
          if (release === 0) { // 待新增
            color = '#50534e';
            backgroundColor = '#f0f9eb';
          } else if (release === 2) { // 待修改
            if (!isTitle && oldContractItem != null && contractItem[key] !== oldContractItem[key]) {
              color = '#e6a23c';
              backgroundColor = '#fdf6ec';
            }
          } else if (release === 3) { // 待删除
            color = '#999999';
            backgroundColor = '#f3f3f3';
          }
        }
        return {
          color: color,
          backgroundColor: backgroundColor,
        };
      },
      getOldDataTag(contractItem, key, flag) {
        let tag = '';
        if (contractItem.oldContractItem != null && contractItem.oldContractItem[key] !== contractItem[key]) {
          tag = '<br/> 原：' + ((key === 'beginDate' || key === 'endDate') ? formatDate(contractItem.oldContractItem[key]) :
              contractItem.oldContractItem[key]);
          if (flag === 1 && contractItem.oldContractItem.contractConfigItem != null &&
              contractItem.oldContractItem.contractConfigItem.calculateUnit != null) { // 添加单位，带元
            tag += `(元/${contractItem.oldContractItem.contractConfigItem.calculateUnit})`;
          } else if (flag === 2 && contractItem.oldContractItem.contractConfigItem != null &&
              contractItem.oldContractItem.contractConfigItem.calculateUnit != null) {// 添加单位，不带元
            tag += `(${contractItem.oldContractItem.contractConfigItem.calculateUnit})`;
          } else if (flag === 3) {
            tag += '%';
          }
        }
        return tag;
      },
      toShow(contractItem) {
        this.emitToShow(contractItem);
      },
      toEdit(contractItem) {
        this.emitToEdit(contractItem);
      },
      toDelete(contractItem) {
        let {contractId, uuid} = contractItem;
        this.$confirm('确定删除吗？', '删除提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          BillingServer.contract.removeContractItemByContractItemUuid(contractId, uuid, {loading: true}).then((res) => {
            if (res.data.code === 200 || res.data.success) {
              // this.loadContractItems(contractId);
              this.emitAfterDelete(contractItem);
              this.$message.success('删除成功！');
            } else {
              this.$message.error(`删除失败：${res.data.responseMessage}`);
            }
          }, (error) => {
            handleError(error);
          });
        }, () => {});
      },
      emitToShow(data) {
        this.$emit('to-show', data);
      },
      emitToEdit(data) {
        this.$emit('to-edit', data);
      },
      emitAfterDelete(contractItem) {
        this.$emit('after-delete', contractItem);
      },
    },
    filters: {
      formatDate(value, format) {
        return formatDate(value, format);
      }
    }
  }
</script>

<style scoped>
  table tr th {
    text-align: right;
  }
  table tr td {
    text-align: left;
  }
</style>
